import { createSelector } from 'reselect'
import { formValueSelector } from 'redux-form'
import { getSkills } from '../redux/modules/skills'

export const editing = createSelector([getSkills], ({ editing }) => editing)
export const loading = createSelector([getSkills], ({ loading }) => loading)
export const searching = createSelector([getSkills], ({ searching }) => searching)

export const skillsList = createSelector([getSkills], ({ data }) => data.map(result => ({ value: result, label: result })))

export const searchResults = createSelector([getSkills], ({ searchResults }) => {
  return searchResults.map(elem => ({
    value: elem.text,
    label: elem.text,
  }))
})

const formSkillsSelection = state => formValueSelector('skills')(state, 'skills')

export const selectedSkillsCount = createSelector([formSkillsSelection], (formSkills = []) =>
  formSkills ? formSkills.filter(elem => elem.value).length : 0,
)
